import { AsYouType } from 'libphonenumber-js';
import { isValidPhoneHelper } from '../utils';

export function isValidPhone(input: string): boolean {
  const asYouType = new AsYouType();
  const formattedPhone = asYouType.input(input);

  return isValidPhoneHelper(formattedPhone);
}
